import { css } from '@emotion/react';
import styled from '@emotion/styled';
import {
  atom,
  useAtom,
  useAtomValue,
  useSetAtom,
} from 'jotai';
import Image from 'next/image';
import EditorViewer from '@/components/comm/EditorViewer';
import Modal from '@/components/comm/Modal';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import icClear from '@/public/images/ic-clear.svg';

const regulationModalShowAtom = atom(false);
const regulationModalContentAtom = atom('');

export const useRegulationModal = () => {
  const setShow = useSetAtom(regulationModalShowAtom);
  const setContent = useSetAtom(regulationModalContentAtom);

  const showRegulation = (content: string) => {
    setShow(true);
    setContent(content);
  };

  return { showRegulation };
};

const Container = styled.section`
position: relative;
display: grid;
max-width: 80vw;
max-height: 95vh;
align-self: center;
background-color: ${colors.white};
border-radius: 15px;
grid-template-rows: max-content 1fr;
@media (max-width: ${breakpointMedium}) {
  max-width: 95vw;
}
`;

const Controls = styled.div`
display: grid;
justify-items: end;
`;

const Close = styled.div`
display: grid;
height: 24px;
box-sizing: content-box;
padding: 8px 20px;
cursor: pointer;
place-items: center;
`;

const Content = styled.div`
overflow: auto;
padding: 0 20px 24px;
`;

const overrideCss = css`
.toastui-editor-contents {
  h1 {
    border-bottom: none;
    margin: 0;
  }
}
`;

const RegulationModal = () => {
  const [show, setShow] = useAtom(regulationModalShowAtom);
  const content = useAtomValue(regulationModalContentAtom);

  return (
    <Modal
      show={[show, setShow]}
      style={{ overflowY: 'hidden' }}
    >
      <Container>
        <Controls>
          <Close
            aria-label="close"
            role="button"
            onClick={() => setShow(false)}
          >
            <Image src={icClear} alt="clear" />
          </Close>
        </Controls>
        <Content>
          <EditorViewer
            initialValue={content}
            overrideCss={overrideCss}
          />
        </Content>
      </Container>
    </Modal>
  );
};

export default RegulationModal;
